import g2 from './src/index.vue'

g2.install = function (Vue) {
  Vue.component(g2.name, g2)
}
export default g2



// WEBPACK FOOTER //
// ./packages/components/g2/index.js